var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GridInvocation,{attrs:{"filtered-for":{
        type: 'History',
        id: _setup.props.historyId,
        name: _setup.historyName,
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }